var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "tabs" },
    _vm._l(_vm.slotsList, function (s, i) {
      return _c(
        "li",
        {
          key: i,
          staticClass: "tabs__item",
          class: {
            active: s.isActive,
            first_item: s.index === 0,
            last_item: s.index === _vm.slotsList.length - 1,
          },
          on: {
            click: function ($event) {
              return _vm.slotHandler(i)
            },
          },
        },
        [_vm._t("slot" + (s.index + 1))],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }